import { Component, OnInit } from '@angular/core';
import { ApiHandlerService } from '../api-handler.service'
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { DomSanitizer,SafeResourceUrl } from '@angular/platform-browser';
import { Title, Meta } from '@angular/platform-browser';  
declare let $: any;
@Component({
  selector: 'app-posts',
  templateUrl: './posts.component.html',
  styleUrls: ['./posts.component.css']
})
export class PostsComponent implements OnInit {
  

  postSlug = null;
  typeSlug = null;
  post:any = null;
  related = [];
  whitepaperForm;
  submit = false;
  html = null;
  previousPostSlug = null;
  nextPostSlug = null;
  constructor(private sanitizer: DomSanitizer, private metaTagService: Meta, private fb: FormBuilder, private apiHandler: ApiHandlerService, private router: ActivatedRoute, private route: Router) { }

  ngOnInit() {
    window.scroll(0,0);
    this.validateParams()
  }

  validateParams(){
    this.router.params.subscribe(prm=>{
       this.typeSlug = prm['id'];
       this.postSlug = prm['post'];
       this.getPost() 
    })  
    
  }

  renderPost(content){
    return this.sanitizer.bypassSecurityTrustHtml(content)
  }

  onBackPress(){
    try{
      let path = '/resources'
      if(this.post != null){
          path = '/resources/'+this.post.type.slug
      }
      this.route.navigate([path])
    }catch(err){
      this.route.navigate(['/resources'])
    }
  }
  onTagPress(tag){
    this.route.navigate(['/resources/all'],{queryParams:{tag:tag.name}})
  }

  getPost(){
    this.post = null;
    let data = {postSlug: this.postSlug, typeSlug: this.typeSlug}
    this.apiHandler.getPostDetail(data).subscribe(
      (result:any) => {        
       console.log("RESULT>>",result)
        this.post = result.data;
        this.removePostMetaTag();
        this.addPostMetaTag();
        this.previousPostSlug = result.previous;
        this.nextPostSlug = result.next;
        this.html = this.post.body; // this.sanitizer.bypassSecurityTrustHtml(this.post.body)
        if(this.post.type.formRequired){
          this.initForm();
        }
        if(this.post != null){
          this.relatedPosts()
        }
    },
    (err:any)=>{
     
      
    }
    )
  }

  addPostMetaTag(){
    this.metaTagService.addTag({property: 'og:title', content: this.post.name});
    this.metaTagService.addTag({property: 'og:description', content: this.post.name});
    this.metaTagService.addTag({property: 'og:image', content: this.post.image});
    this.metaTagService.addTag({property: 'og:url', content: window.location.href});
    this.metaTagService.addTag({property: 'og:type', content: 'article'});
    this.metaTagService.addTag({property: 'og:site_name', content: 'OMNI'});
    this.metaTagService.addTag({property: 'og:locale', content: 'en_US'});
    this.metaTagService.addTag({property: 'twitter:card', content: this.post.name});
    this.metaTagService.addTag({property: 'twitter:site', content: 'omnicoe.com'});
    this.metaTagService.addTag({property: 'twitter:creator', content: 'OMNI'});
    this.metaTagService.addTag({property: 'twitter:title', content: this.post.name});
    this.metaTagService.addTag({property: 'twitter:description', content: this.post.name});
    this.metaTagService.addTag({property: 'twitter:image', content: this.post.image});
  }

  removePostMetaTag(){
    this.metaTagService.removeTag('property="og:title"');
    this.metaTagService.removeTag('property="og:description"');
    this.metaTagService.removeTag('property="og:image"');
    this.metaTagService.removeTag('property="og:url"');
    this.metaTagService.removeTag('property="og:type"');
    this.metaTagService.removeTag('property="og:site_name"');
    this.metaTagService.removeTag('property="og:locale"');
    this.metaTagService.removeTag('property="twitter:card"');
    this.metaTagService.removeTag('property="twitter:site"');
    this.metaTagService.removeTag('property="twitter:creator"');
    this.metaTagService.removeTag('property="twitter:title"');
    this.metaTagService.removeTag('property="twitter:description"');
    this.metaTagService.removeTag('property="twitter:image"');
  }

  initForm(){
    this.whitepaperForm = this.fb.group({     
      name: ['', [Validators.required, Validators.pattern('^\\s*[a-zA-Z ]*\\s*$')]],
      email: ['', [Validators.required, Validators.email]],
      // contact: ['', Validators.pattern(/^(0|[1-9]\d*)$/)],
      company: [''],
      jobTitle: [''],
      // message: ['']
    })
  }

  get whitepaperFormControl() {
    return this.whitepaperForm.controls;
  }

  relatedPosts(){
    let tags = this.post.tags!=undefined?this.post.tags.map((tag)=> {return tag.name}):[]
    let data = {tags:tags, page:1, limit:3}
    this.apiHandler.getPosts(data).subscribe(
      (result:any) => {        
       if(result != null && result.data != null && result.data != undefined){
        this.related = result.data.filter((pst)=>{
          return  pst._id != this.post._id
        });
       }
    },
    (err:any)=>{
     
      
    }
    )
  }


  onPostClick(post){
    if(post){
      this.route.navigate(['/resources/'+post.type.slug+"/"+post.slug]).then(()=>{
        window.scroll(0,0);
      })
    }
  }

  submitWhitePaper(){
    this.submit = true;
    if(this.whitepaperForm.valid){
      this.whitepaperForm.value.name = this.whitepaperForm.value.name.trim();
      this.whitepaperForm.value.email = this.whitepaperForm.value.email.trim();
      this.whitepaperForm.value.company = this.whitepaperForm.value.company ? this.whitepaperForm.value.company.trim() : this.whitepaperForm.value.company;
      this.whitepaperForm.value.jobTitle = this.whitepaperForm.value.jobTitle ? this.whitepaperForm.value.jobTitle.trim() : this.whitepaperForm.value.jobTitle;
      // this.whitepaperForm.value.message = this.whitepaperForm.value.message ? this.whitepaperForm.value.message.trim() : this.whitepaperForm.value.message;
      this.whitepaperForm.value.postId = this.post.reference;
      this.apiHandler.submitWhitepaperRequest(this.whitepaperForm.value).subscribe(
        result => {
          console.log(result);
           $('#thanks-modal').modal('show');
           this.whitepaperForm.reset();
           this.submit = false;
      },
      err=>{
        console.error("Become partner Error ==>", err);
        
      }
      )
    }
  }

  onSocialShare(platform){
    const url = encodeURIComponent(window.location.href);
    //const url = encodeURIComponent("https://omni-marketing-qa.web.app/resources/whitepapers/new-white-paper");

    switch (platform) {
      case 'fb':
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, '_blank','height=570,width=520,scrollbars=yes,status=yes');
        break;
      case 'tw':
        window.open(`https://twitter.com/intent/tweet?url=${url}`, '_blank','height=570,width=520,scrollbars=yes,status=yes');
        break;
      case 'in':
        window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${url}`, '_blank','height=570,width=520,scrollbars=yes,status=yes');
        break;
      default:
        break;
    }  
  }

  onPrevNextPostClick(postSlug){
    if(postSlug){
      this.route.navigate(['/resources/'+this.post.type.slug+"/"+postSlug])
    }
  }

}
